var map = {
	"./additionalInfoIcon.svg": 624,
	"./arrowLeftIcon.svg": 625,
	"./arrowMediumTop.svg": 626,
	"./arrowRightIcon.svg": 627,
	"./arrowRightIconSharp.svg": 628,
	"./arrowRightSmallIcon.svg": 629,
	"./arrowScalableIcon.svg": 630,
	"./arrowSelect2.svg": 631,
	"./arrowSelectIcon.svg": 632,
	"./benefit1.svg": 633,
	"./benefit2.svg": 634,
	"./benefit3.svg": 635,
	"./cardsIcon.svg": 636,
	"./crossIcon.svg": 637,
	"./crossIcon2.svg": 638,
	"./crossIcon3.svg": 639,
	"./crossIconSmall.svg": 640,
	"./crossSmallIcon.svg": 641,
	"./defaultCategoryIcon.svg": 642,
	"./depNumberIcon.svg": 643,
	"./elfCentralIcon.svg": 644,
	"./equalitySign.svg": 645,
	"./errorIcon.svg": 646,
	"./eyeClosedIcon.svg": 647,
	"./eyeOpenIcon.svg": 648,
	"./favoritesIcon.svg": 649,
	"./favoritesLabelIcon.svg": 650,
	"./filterDivider.svg": 651,
	"./filterIcon.svg": 652,
	"./frequencyIcon.svg": 653,
	"./fsAmountIcon.svg": 654,
	"./fullScreenIcon.svg": 655,
	"./gameIcon.svg": 656,
	"./hamburgerIcon.svg": 657,
	"./infoIcon.svg": 658,
	"./infoSymbol.svg": 659,
	"./levelBackground.svg": 660,
	"./levelBackgroundNew.svg": 661,
	"./linkIcon.svg": 662,
	"./lockIcon.svg": 663,
	"./maxBonusAmountIcon.svg": 664,
	"./maxWinFsIcon.svg": 665,
	"./menu/fortuneIcon.svg": 392,
	"./menu/fortuneIconL.svg": 393,
	"./menu/helpdeskIcon.svg": 394,
	"./menu/helpdeskIconL.svg": 395,
	"./menu/homeIcon.svg": 396,
	"./menu/homeIconLarge.svg": 397,
	"./menu/jackpotIcon.svg": 398,
	"./menu/logo.svg": 399,
	"./menu/logoSmall.svg": 400,
	"./menu/loyaltyIcon.svg": 401,
	"./menu/mobileAppIcon.svg": 402,
	"./menu/profileIcon.svg": 403,
	"./menu/questIcon.svg": 404,
	"./menu/rewardLineupIcon.svg": 405,
	"./menu/searchIcon.svg": 406,
	"./menu/searchIconLarge.svg": 407,
	"./menu/signOutIcon.svg": 408,
	"./menu/star.svg": 409,
	"./menu/tournamentIcon.svg": 410,
	"./menu/tournamentLargeIcon.svg": 411,
	"./menu/vipIcon.svg": 412,
	"./menu/wheelIcon.svg": 413,
	"./menu/wheelIconL.svg": 414,
	"./menu/wheelIconMobile.svg": 415,
	"./menuIcon.svg": 666,
	"./minDepIcon.svg": 667,
	"./noTournamentIcon.svg": 668,
	"./numbers/number-1.svg": 416,
	"./numbers/number-2.svg": 417,
	"./numbers/number-3.svg": 418,
	"./numbers/number-4.svg": 419,
	"./numbers/number-5.svg": 420,
	"./numbers/number-6.svg": 421,
	"./numbers/number-7.svg": 422,
	"./numbers/number-8.svg": 423,
	"./numbers/number-9.svg": 424,
	"./numbers/number-shine-1.svg": 425,
	"./numbers/number-shine-2.svg": 426,
	"./numbers/number-shine-3.svg": 427,
	"./numbers/number-shine-4.svg": 428,
	"./numbers/number-shine-5.svg": 429,
	"./numbers/number-shine-6.svg": 430,
	"./numbers/number-shine-7.svg": 431,
	"./numbers/number-shine-8.svg": 432,
	"./numbers/number-shine-9.svg": 433,
	"./playIcon.svg": 669,
	"./polygon.svg": 670,
	"./preloaderDotsAnimation.svg": 671,
	"./preloaderSpinnerAnimation.svg": 672,
	"./promoIcon.svg": 673,
	"./recentIcon.svg": 674,
	"./search2Icon.svg": 675,
	"./search3Icon.svg": 676,
	"./smallInfoSymbol.svg": 677,
	"./successIcon.svg": 678,
	"./supportIcon.svg": 679,
	"./tag1Icon.svg": 680,
	"./tag2Icon.svg": 681,
	"./tag3Icon.svg": 682,
	"./tag4Icon.svg": 683,
	"./tickIcon.svg": 684,
	"./unverified.svg": 685,
	"./verified.svg": 686,
	"./wagerIcon.svg": 687,
	"./wagerTimeIcon.svg": 688,
	"./warningIcon.svg": 689
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 623;